import RecreationGovClient from "../externalclients/RecreationGovClient";

//Retrieves pass type definitions from R1S
export default class PassTypeService {
  getPassTypesDefinition(siteId) {
    let client = new RecreationGovClient();
    return client.getParkPassTypes(siteId);
  }

  getPassType(passDefinition, passTypeId) {
    return passDefinition.pass_types.find(n => n.id === passTypeId);
  }
}
